<template>
    <div :class="['grid gap-4 items-end mt-12', form.check.fields.type.type === 'select' ? 'grid-cols-17' : 'grid-cols-14']">
        <div v-if="form.check.fields.type.type === 'select'" class="col-span-3">
            <FormField :field="form.check.fields.type" name="type" namespace="check" />
        </div>
        <div class="col-span-3">
            <FormField :field="form.check.fields.category" name="category" namespace="check" />
        </div>
        <div class="col-span-3">
            <FormField :field="form.check.fields.event_date" name="event_date" namespace="check" />
        </div>
        <div class="col-span-6">
            <FormField :field="form.check.fields.summary" name="summary" namespace="check" />
        </div>
        <div class="col-span-2">
            <Button :onClick="() => save()" width="w-full">Add</Button>
        </div>
    </div>
</template>

<script>
import { reactive, computed, watch, onBeforeMount } from "vue"
import { getPayload, isValid } from "@lib/helpers"
import { useCheckStore } from "@sto/check.store"
import { useSystemStore } from "@sto/system.store"

export default {
    props: ['asset_id', 'refresh', 'create_types'],
    setup (props, {emit}) {

        const SYSTEM_STORE = useSystemStore()
        const CHECK_STORE = useCheckStore()

        const state = reactive({
            loading: false,
            check_type_options: [
                { value: 'vehicle:manual_check', label: 'Manual HPI Check' },
                { value: 'vehicle:insurance_damages', label: 'Insurance write off (Damages)' },
                { value: 'vehicle:insurance_thefts', label: 'Insurance write off (Theft)' },
                { value: 'vehicle:insurance_inspections', label: 'Insurance Inspections' },
                { value: 'vehicle:plate_transfers', label: 'Plate transfer' },
                { value: 'vehicle:security_watch', label: 'Security watch' },
                { value: 'vehicle:finance_agreements', label: 'Finance agreements' },
                { value: 'vehicle:stolen_incidents', label: 'Stolen incidents' }
            ]
        })

        const form = reactive({
            check: {
                fields: {
                    // type: {
                    //     active: true,
                    //     label: 'Type of Check',
                    //     placeholder: 'Select a time',
                    //     type: 'select',
                    //     value: '09:00:00',
                    //     options: [
                    //         { value: 'vehicle:manual_check', label: 'Manual HPI Check' },
                    //         { value: 'vehicle:insurance_damages', label: 'Insurance write off (Damages)' },
                    //         { value: 'vehicle:insurance_thefts', label: 'Insurance write off (Theft)' },
                    //         { value: 'vehicle:insurance_inspections', label: 'Insurance Inspections' }
                    //     ],
                    //     stored_value: '',
                    //     required: true,
                    //     pristine: true,
                    //     valid: false,
                    //     message: '',
                    //     validation: [],
                    //     notes: '',
                    // },
                    type: {
                        active: true,
                        label: 'Type of Check',
                        placeholder: 'Select a time',
                        type: 'hidden',
                        value: 'vehicle:manual_check',
                        starting_value: 'vehicle:manual_check',
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                    },
                    category: {
                        active: true,
                        label: 'Category',
                        type: 'select',
                        value: 'tba',
                        starting_value: 'tba',
                        options: [
                            { value: 'tba', label: 'TBA' },
                            { value: 'clear', label: 'Clear' },
                            { value: 'N', label: 'Category N' },
                            { value: 'S', label: 'Category S' },
                            { value: 'D', label: 'Category D' },
                            { value: 'C', label: 'Category C' },
                        ],
                        stored_value: '',
                        required: true,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                    },
                    event_date: {
                        active: true,
                        label: 'Date (Optional)',
                        type: 'datepicker',
                        value: '',
                        starting_value: '',
                        stored_value: '',
                        min_date: null,
                        time_enabled: false,
                        date_format: 'dd-MM-yyyy',
                        date_clearable: true,
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                    },
                    summary: {
                        active: true,
                        label: 'Notes (Optional)',
                        placeholder: '',
                        type: 'text',
                        value: '',
                        starting_value: '',
                        stored_value: '',
                        required: false,
                        pristine: true,
                        valid: false,
                        message: '',
                        validation: [],
                        notes: '',
                    }
                }
            }
        })

        const save = async () => {
            if (state.loading || !isValid(form.check.fields)) return

            try {
                state.loading = true
                await CHECK_STORE.createAssetInsuranceCheck(
                    props.asset_id,
                    form.check.fields.type.value || null,
                    form.check.fields.category.value || null,
                    form.check.fields.event_date.value || null,
                    form.check.fields.summary.value || null
                )
                SYSTEM_STORE.addSuccess('Check added')
                clearForm()
                if (props.refresh) props.refresh()

            } catch (error) {
                console.error('CHECK_STORE.createAssetInsuranceCheck error', error)
                SYSTEM_STORE.addError('Error', error?.message || 'There was a problem storing the check details')

            } finally {
                state.loading = false
            }
        }

        const clearForm = () => {
            for (let field in form.check.fields) {
                form.check.fields[field].value = form.check.fields[field].starting_value || ''
            }
        }

        const setCreateTypes = () => {
            let create_types = []
            if (props.create_types) {
                if (typeof props.create_types === 'string') {
                    create_types = props.create_types.split(',')
                } else if (Array.isArray(props.create_types)) {
                    create_types = props.create_types
                }
            }

            if (create_types.length === 1) {
                form.check.fields.type.type = 'hidden'
                form.check.fields.type.value = create_types[0]

            } else if (create_types.length > 1) {
                form.check.fields.type.type = 'select'
                form.check.fields.type.value = create_types[0]
                form.check.fields.type.options = state.check_type_options.filter(op => {
                    return create_types.includes(op.value)
                })

            } else {
                form.check.fields.type.type = 'select'
                form.check.fields.type.value = state.check_type_options[0].value
                form.check.fields.type.options = state.check_type_options
            }
        }

        watch (
            () => props.create_types,
            () => {
                setCreateTypes()
            }
        )

        onBeforeMount(() => {
            setCreateTypes()
        })

        return {
            state,
            form,
            save
        }
    }
}
</script>